import styled from "styled-components";

export const AutocompleteView = styled.div<{
  $open: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;

  & > label.input-label {
    margin-bottom: ${({ theme }) => theme.spacing.x_small }px;
    color: ${({ theme }) => theme.colors.text.secondary };

    min-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-size: ${({ theme }) => theme.font_size.xx_small }px;
    line-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-weight: ${({ theme }) => theme.typography.weight.semibold };
  }

  & > div.field-view {
    position: relative;
    min-width: 0;
    min-height: 40px;
    border-radius: ${({ theme }) => theme.border_radius.medium }px;
    border-bottom-left-radius: ${({ theme, $open }) => $open ? 0 : theme.border_radius.medium  }px;
    border-bottom-right-radius: ${({ theme, $open }) => $open ? 0 : theme.border_radius.medium  }px;
    border: 1px solid ${({ theme, $open }) => $open ? theme.palette.primary : theme.colors.border.default};
    border-width: 1px 1px ${({ $open }) => $open ? 0 : 1 }px 1px;
    box-shadow: ${({ theme, $open }) => $open ? `0 0 0 3px ${ theme.palette.primary }33` : "none"};

    transition: border-color ${({ theme }) => theme.transitions.fast }, box-shadow ${({ theme }) => theme.transitions.fast };
    transition-delay: ${({ $open }) => !$open ? ".2s" : "0s" };
  }

  & > div.field-view > div.trigger-button {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing.xx_small }px;
    width: 100%;
    min-width: 0;
    padding: ${({ theme }) => theme.spacing.xx_small }px;
    border: none;
    background-color: ${({ theme }) => theme.palette.surface };
    border-radius: ${({ theme }) => theme.border_radius.medium }px;
    color: ${({ theme }) => theme.colors.text.default };

    cursor: pointer;
  }

  & > div.field-view > div.trigger-button > span.placeholder {
    flex: 1;
    min-width: 0;
    text-align: left;
    min-height: ${({ theme }) => theme.font_size.xxx_small }px;
    font-size: ${({ theme }) => theme.font_size.xxx_small }px;
    line-height: ${({ theme }) => theme.font_size.xxx_small }px;

    color: ${({ theme }) => theme.colors.text.muted };
  }

  & > div.field-view > div.trigger-button > div.selected-item {
    flex: 1;
    min-width: 0;
    min-height: ${({ theme }) => theme.font_size.xxx_small }px;
    font-size: ${({ theme }) => theme.font_size.xxx_small }px;
    line-height: ${({ theme }) => theme.font_size.xxx_small }px;

    color: ${({ theme }) => theme.colors.text.default };
  }

  & > div.field-view > div.trigger-button > .icon-view {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
  }

  & > div.field-view > div.trigger-button:active {
    transform: scale( .99 );
    opacity: .95;
  }

  & > div.field-view > div.options-view {
    display: flex;
    flex-direction: column;
    position: absolute;
    inset: -1px;
    top: 39px;
    overflow: hidden;
    height: ${({ $open }) => $open ? 240 : 0}px;
    border-bottom-left-radius: ${({ theme, $open }) => !$open ? 0 : theme.border_radius.medium  }px;
    border-bottom-right-radius: ${({ theme, $open }) => !$open ? 0 : theme.border_radius.medium  }px;
    z-index: 1;
    background-color: ${({ theme }) => theme.palette.elevated };
    border: 1px solid ${({ theme, $open }) => $open ? theme.palette.primary : theme.colors.border.default};
    border-width: ${({ $open }) => !$open ? 0 : 1 }px;
    box-shadow: ${({ theme, $open }) => $open ? theme.shadow.default : "none"};

    transition: height ${({ theme }) => theme.transitions.default }, border-color ${({ theme }) => theme.transitions.fast };
    transition-delay: ${({ $open }) => $open ? ".1s" : "0s" };
  }

  & > div.field-view > div.options-view > div.input-search-view {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: ${({ theme }) => theme.spacing.xx_small }px;
    padding: ${({ theme }) => theme.spacing.xx_small }px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.default };
  }

  & > div.field-view > div.options-view > div.input-search-view > input {
    width: 100%;
    padding: ${({ theme }) => theme.spacing.xx_small }px;
    background-color: transparent;
    border: none;
    border-radius: ${({ theme }) => theme.border_radius.medium }px;
    border: 1px solid ${({ theme }) => theme.colors.border.default};

    min-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-size: ${({ theme }) => theme.font_size.xx_small }px;
    line-height: ${({ theme }) => theme.font_size.xx_small }px;

    color: ${({ theme }) => theme.colors.text.default };

    transition: border-color ${({ theme }) => theme.transitions.fast }, box-shadow ${({ theme }) => theme.transitions.fast };
  }

  & > div.field-view > div.options-view > div.input-search-view > input:focus-visible {
    outline: none;
    border: 1px solid ${({ theme }) => theme.palette.primary };
    box-shadow: 0 0 0 3px ${({ theme }) => theme.palette.primary }33;
  }

  & > div.field-view > div.options-view > div.input-search-view > input::placeholder {
    min-height: ${({ theme }) => theme.font_size.xx_small }px;
    font-size: ${({ theme }) => theme.font_size.xx_small }px;
    line-height: ${({ theme }) => theme.font_size.xx_small }px;

    color: ${({ theme }) => theme.colors.text.muted };
  }

  & > div.field-view > div.options-view > div.full {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing.xxx_small }px;
  }

  & > span.input-error-message {
    margin-top: ${({ theme }) => theme.spacing.x_small }px;
    margin-left: ${({ theme }) => theme.spacing.xx_small }px;
    color: ${({ theme }) => theme.colors.error.default };

    min-height: ${({ theme }) => theme.font_size.x_small }px;
    font-size: ${({ theme }) => theme.font_size.x_small }px;
    line-height: ${({ theme }) => theme.font_size.x_small }px;
  }
`;

export const ItemView = styled.button.attrs({
  type: "button",
})`
  display: flex;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.xx_small }px;
  background-color: transparent;
  border: none;
  cursor: pointer;

  min-height: ${({ theme }) => theme.font_size.xxx_small }px;
  font-size: ${({ theme }) => theme.font_size.xxx_small }px;
  line-height: ${({ theme }) => theme.font_size.xxx_small }px;
  color: ${({ theme }) => theme.colors.text.default };
  transition: background-color ${({ theme }) => theme.transitions.fast };

  &:hover {
    background-color: ${({ theme }) => theme.palette.surfaceHover };
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.primaryHover };
    outline-offset: -2px;
  }
`;
